import useLanguage from '~/contexts/language/useLanguage'
import useTranslator from '~/lib/useTranslator'

export default function DownloadFeatures() {
  const lang = useLanguage()
  const Translator = useTranslator()

  return (
    <div className="md:hidden">
      <div className="w-full max-w-[620px] mx-auto">
        <img
          src={`/images/${lang}/download-product.png`}
          width={620}
          height={711}
          alt="Download Heja app graphic"
        />
      </div>
      <section className="flex flex-col gap-8 px-4 text-center mt-8 mb-24">
        <article>
          <h2 className="text-[#3c1e82] font-medium text-3xl">
            {Translator.singular('For parents')}
          </h2>
          <p className="text-lg">
            {Translator.singular(
              'Youth sports are a commitment for the whole family. Heja gives you the tools you need to make your everyday life as simple as possible, so that you can focus on being your child’s biggest fan.'
            )}
          </p>
        </article>

        <article className="bg-white rounded-xl px-4 py-8">
          <h2 className="text-[#3c1e82] font-medium text-3xl">
            {Translator.singular('For coaches')}
          </h2>
          <p className="text-lg">
            {Translator.singular(
              'Forget endless emails, texts and WhatsApp groups. Heja takes the stress out of organizing games and practices, saves you time and lets you focus on what you do best: bringing the best out of young athletes.'
            )}
          </p>
        </article>

        <article>
          <h2 className="text-[#3c1e82] font-medium text-3xl">
            {Translator.singular('For players')}
          </h2>
          <p className="text-lg">
            {Translator.singular(
              'From the thrill of winning to the shared pain of a loss, and all the moments of joy inbetween, nothing brings people together like team sports. We created Heja to make it easier for everybody to enjoy the magic of team sports.'
            )}
          </p>
        </article>
      </section>
    </div>
  )
}
